import * as angular from "angular";

import {tinyMceWrapperConfig} from './component/tinymce-wrapper.component';

export default angular
    .module('mw.tinymce', ['ui.tinymce'])
    .component(tinyMceWrapperConfig.selector, tinyMceWrapperConfig)
    .name;



/** WEBPACK FOOTER **
 ** ./apps-ts/outputs/src/app/wysiwyg/tinymce/tinymce-wrapper.module.ts
 **/